import { RESET_COVERAGE_FORM } from '../actionTypes';
import { configurationCoveragesActions } from '../reducer';

export default () => configurationCoveragesActions[RESET_COVERAGE_FORM]();
